<div class="reports-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <h2 class="page-title">
        <mat-icon>assessment</mat-icon>
        Daily Labour Reports
      </h2>
      <button class="btn-primary-large" (click)="addNewReport()">
        <mat-icon>add</mat-icon>
        <span>Add New Report</span>
      </button>
    </div>
  </div>

  <!-- Filters Card -->
  <div class="filter-card">
    <div class="filter-grid">
      <div class="filter-item">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          class="filter-input"
          placeholder="Search reports..."
          [(ngModel)]="searchKeyword"
          (keyup.enter)="applyFilter()"
        />
      </div>
      
      <div class="filter-item">
        <mat-icon>business</mat-icon>
        <select class="filter-select" [(ngModel)]="selectedProject" (change)="onFilterChange()">
          <option value="">All Projects</option>
          <option *ngFor="let project of projects" [value]="project.id">
            {{ project.project_name }}
          </option>
        </select>
      </div>
      
      <div class="filter-item">
        <mat-icon>schedule</mat-icon>
        <select class="filter-select" [(ngModel)]="selectedShiftType" (change)="onFilterChange()">
          <option value="">All Shifts</option>
          <option *ngFor="let shift of shiftTypes" [value]="shift.value">
            {{ shift.label }}
          </option>
        </select>
      </div>
      
      <div class="filter-item">
        <mat-icon>calendar_today</mat-icon>
        <input
          type="date"
          class="filter-input"
          [(ngModel)]="startDate"
          (change)="onFilterChange()"
          placeholder="Start Date"
        />
      </div>
      
      <div class="filter-item">
        <mat-icon>event</mat-icon>
        <input
          type="date"
          class="filter-input"
          [(ngModel)]="endDate"
          (change)="onFilterChange()"
          placeholder="End Date"
        />
      </div>
      
      <button class="btn-filter" (click)="applyFilter()">
        <mat-icon>filter_list</mat-icon>
        <span>Apply</span>
      </button>
    </div>
  </div>

  <!-- Reports Table -->
  <div class="table-card">
    <div class="table-responsive-modern">
      <table mat-table [dataSource]="dataSource" matSort class="modern-table">
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="cell-center">
            {{ (pagination.current_page - 1) * pagination.items_per_page + i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="report_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let element">
            <span class="date-badge">{{ formatDate(element.report_date) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="project_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Project</th>
          <td mat-cell *matCellDef="let element" class="project-cell">
            <div class="project-info">
              <strong>{{ element.project_name || element.project_identifier }}</strong>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="contractor_name">
          <th mat-header-cell *matHeaderCellDef>Contractor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.contractor_name || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="client_name">
          <th mat-header-cell *matHeaderCellDef>Client</th>
          <td mat-cell *matCellDef="let element">
            {{ element.client_name || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="shift_type">
          <th mat-header-cell *matHeaderCellDef>Shift</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge-modern badge-shift">{{ element.shift_type || 'day' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="total_manhours">
          <th mat-header-cell *matHeaderCellDef class="cell-right">Total Manhours</th>
          <td mat-cell *matCellDef="let element" class="cell-right">
            <span class="total-badge">{{ getTotalManhours(element) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="cell-center">Actions</th>
          <td mat-cell *matCellDef="let element" class="cell-center">
            <div class="action-group">
              <button mat-icon-button class="btn-action-view" (click)="viewReport(element)" matTooltip="View">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button class="btn-action-edit" (click)="editReport(element)" matTooltip="Edit">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="btn-action-delete" (click)="deleteReport(element)" matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="pagination.total_items"
      [pageSize]="pagination.items_per_page"
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      class="modern-paginator">
    </mat-paginator>

    <div *ngIf="loading" class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading reports...</p>
    </div>

    <div *ngIf="!loading && dataSource.data.length === 0" class="empty-state">
      <mat-icon>description</mat-icon>
      <h3>No Reports Found</h3>
      <p>Start by creating a new daily labour report</p>
      <button class="btn-primary" (click)="addNewReport()">
        <mat-icon>add</mat-icon>
        Create First Report
      </button>
    </div>
  </div>
</div>
